import { render, staticRenderFns } from "./timetactics.vue?vue&type=template&id=6f36d1d6&scoped=true"
import script from "./timetactics.vue?vue&type=script&lang=js"
export * from "./timetactics.vue?vue&type=script&lang=js"
import style0 from "./timetactics.vue?vue&type=style&index=0&id=6f36d1d6&prod&scoped=true&lang=css"
import style1 from "./timetactics.vue?vue&type=style&index=1&id=6f36d1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f36d1d6",
  null
  
)

export default component.exports